import {
  ArrowUpRight,
  Link,
  ChevronDown,
  useTranslation,
  useLocation,
  useNavigate,
} from "../../vendor/api.js"; // Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 24597, offsets 1158:138599. Structure and names inferred from code, not screenshots.
import * as React from "react";
import * as ClassNamesModule from "../../utils/classNames.js";
import * as LocaleContext from "../../i18n/I18nProvider.jsx";
import * as AnalyticsContext from "../../analytics/AnalyticsProvider.jsx";
import * as LocalizedPathsModule from "../../routing/localizedPaths.js";
import * as AnnouncementModule from "../../config/announcement.js";
import * as DestinationsModule from "../../config/destinations.js";
import { createNavigation } from "../../content/navigation.js";
import { InviteLogo } from "../InviteCodeModal.jsx";
import * as jsxRuntime from "react/jsx-runtime";
var NewBadge = () => (
  <span
    className={
      "inline-block rounded bg-[#FFE7CC] px-[4px] py-[1px] text-[#B26206] text-[10px]"
    }
  >
    {"NEW"}
  </span>
);
function DropdownItem({ item: item }) {
  let t = (
    <div
      className={
        "flex w-full cursor-pointer items-center rounded-[6px] px-[8px] py-[6px] hover:bg-[var(--color-surface-hover)]"
      }
    >
      <span className={"flex min-w-0 flex-1 items-center gap-1"}>
        <span
          className={
            "text-[14px] leading-[20px] tracking-[-0.16px] text-[#282828] break-words"
          }
        >
          {item.label}
        </span>
        {item.isNew && <NewBadge />}
      </span>
      {item.external && (
        <ArrowUpRight size={14} className={"ml-1 shrink-0 text-black"} />
      )}
    </div>
  );
  return item.onClick && !item.href ? (
    <div onClick={item.onClick} className={"block w-full"}>
      {t}
    </div>
  ) : item.external ? (
    <a
      href={item.href}
      target={"_blank"}
      rel={"noopener noreferrer"}
      className={"block w-full"}
      onClick={item.onClick}
    >
      {t}
    </a>
  ) : (
    <Link to={item.href} className={"block w-full"} onClick={item.onClick}>
      {t}
    </Link>
  );
}
function DropdownSections({ sections: sections }) {
  return (
    <div
      className={
        "bg-white border border-[var(--color-border-warm)] rounded-[6px] py-[16px] px-[12px] w-[204px] flex flex-col gap-[8px]"
      }
    >
      {sections.map((e, t) => (
        <div key={t} className={"flex flex-col gap-px"}>
          {t > 0 && (
            <div
              className={"bg-[var(--color-border-warm)] h-px w-full mb-[8px]"}
            />
          )}
          {e.heading && (
            <div className={"pb-[8px] pl-[8px] pr-[12px]"}>
              <p
                className={
                  "text-[13px] leading-[14px] tracking-[-0.16px] text-[var(--color-text-secondary)] whitespace-nowrap"
                }
              >
                {e.heading}
              </p>
            </div>
          )}
          <div className={"flex flex-col gap-px"}>
            {e.items.map((e, t) => (
              <DropdownItem key={e.href || `onclick-${t}`} item={e} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
function DropdownColumns({ columns: columns }) {
  return (
    <div
      className={
        "bg-white border border-[var(--color-border-warm)] rounded-[6px] py-[16px] px-[12px] flex gap-[12px]"
      }
    >
      {columns.map((e, t) => (
        <React.Fragment key={t}>
          {t > 0 && (
            <div
              className={"w-px self-stretch bg-[var(--color-border-warm)]"}
            />
          )}
          <div className={"flex flex-col gap-px w-[204px] pt-[8px]"}>
            {e.heading && (
              <div className={"pb-[8px] pl-[8px] pr-[12px]"}>
                <p
                  className={
                    "text-[13px] leading-[14px] tracking-[-0.16px] text-[var(--color-text-secondary)] whitespace-nowrap"
                  }
                >
                  {e.heading}
                </p>
              </div>
            )}
            <div className={"flex flex-col gap-px "}>
              {e.items.map((e, t) => (
                <DropdownItem key={e.href || `onclick-${t}`} item={e} />
              ))}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
let LanguagePlaceholder = () => null;
function NavItem({
  label: label,
  href: href,
  hasDropdown: hasDropdown,
  isOpen: isOpen,
  onMouseEnter: onMouseEnter,
  onMouseLeave: onMouseLeave,
}) {
  let l = (
    <div
      className={(0, ClassNamesModule.cn)(
        "flex items-center gap-[4px] h-[36px] px-[12px] py-[8px] rounded-[6px] cursor-pointer transition-colors hover:bg-[var(--color-border-warm)]",
        isOpen ? "bg-[var(--color-border-warm)]" : "",
      )}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span
        className={"text-[14px] leading-[22px] text-black whitespace-nowrap"}
      >
        {label}
      </span>
      {hasDropdown && (
        <ChevronDown
          size={12}
          className={(0, ClassNamesModule.cn)(
            "text-black",
            isOpen && "-scale-y-100",
          )}
        />
      )}
    </div>
  );
  return href && !hasDropdown ? (
    <Link
      to={href}
      className={"block"}
      target={href.startsWith("http") ? "_blank" : undefined}
    >
      {l}
    </Link>
  ) : (
    l
  );
}
var DesktopNav = () => {
  let { t: translate } = useTranslation(),
    { language: language, setLanguage: setLanguage } = (0,
    LocaleContext.useI18n)(),
    { pathname: pathname, search: search, hash: hash } = useLocation(),
    s = useNavigate(),
    { track: track } = (0, AnalyticsContext.useAnalytics)(),
    [d, p] = (0, React.useState)(null),
    f = (0, React.useRef)(null),
    [M, y] = (0, React.useState)(false),
    N = "/token-plan" === pathname,
    b = !(pathname.startsWith("/docs") || pathname.startsWith("/test-docs")),
    k = "/" === pathname;
  (0, React.useEffect)(() => {
    if (!b) return;
    let e = document.querySelector("main"),
      t = () => y((e?.scrollTop ?? window.scrollY) > 0);
    return (
      t(),
      e?.addEventListener("scroll", t, {
        passive: true,
      }),
      window.addEventListener("scroll", t, {
        passive: true,
      }),
      () => {
        (e?.removeEventListener("scroll", t),
          window.removeEventListener("scroll", t));
      }
    );
  }, [b]);
  let T = () => {
      f.current = setTimeout(() => {
        p(null);
      }, 120);
    },
    C = (e) => {
      (setLanguage(e),
        (0, LocalizedPathsModule.CT)(pathname) &&
          s((0, LocalizedPathsModule.ee)(pathname, e) + search + hash, {
            replace: true,
          }),
        p(null));
    },
    w = (e) => ({
      onMouseEnter: () => {
        (f.current && (clearTimeout(f.current), (f.current = null)), p(e));
      },
      onMouseLeave: T,
    }),
    navigation = createNavigation(translate),
    A = navigation.modelGroups,
    D = navigation.newsGroups,
    v = navigation.usageGroups,
    I = navigation.pricingGroups,
    P = b && M,
    S = pathname.startsWith("/docs"),
    z = pathname.startsWith("/console"),
    L = S || z,
    E = "";
  return (
    S ? (E = translate("nav.docs")) : z && (E = translate("nav.console")),
    (
      <nav
        className={(0, ClassNamesModule.cn)(
          "hidden [@media(min-width:920px)]:block w-full h-[54px] py-[4px] transition-colors",
          P
            ? "bg-[rgba(252,250,248,0.85)] backdrop-blur-[20px] dark:bg-[rgba(255,255,255,0.9)]"
            : "bg-transparent",
        )}
      >
        <div
          className={(0, ClassNamesModule.cn)(
            "flex items-center justify-between mx-auto h-full",
            k
              ? "w-[calc(100%-56px)] max-w-[1260px] px-0 [@media(min-width:1440px)]:w-full"
              : "w-full max-w-[1440px] px-[24px]",
          )}
        >
          <div className={"flex items-center gap-3"}>
            <a
              href={"https://www.15token.win/home"}
              target={"_blank"}
              rel={"noopener noreferrer"}
              className={
                "inline-grid grid-cols-[max-content] grid-rows-[max-content] leading-[0] place-items-start cursor-pointer hover:opacity-80 transition-opacity shrink-0"
              }
              title={translate("nav.home")}
              aria-label={translate("nav.home")}
            >
              <div className={"h-[28px]"}>
                <img
                  src={"/images/15token-logo.png"}
                  alt={translate("nav.home")}
                  className={"h-full w-auto object-contain"}
                />
              </div>
            </a>
            {L && (
              <jsxRuntime.Fragment>
                <div className={"w-[1px] h-[16px] bg-[#D9D9D9]"} />
                <div
                  className={
                    "text-[16px] leading-[22px] text-black whitespace-nowrap"
                  }
                >
                  {E}
                </div>
              </jsxRuntime.Fragment>
            )}
          </div>
          <div className={"flex items-center gap-[4px]"}>
            <NavItem
              label={navigation.research.label}
              href={navigation.research.href}
            />
            <div className={"relative"} {...w("model")}>
              <NavItem
                label={translate("nav.model")}
                hasDropdown={true}
                isOpen={"model" === d}
              />
              {"model" === d && (
                <div
                  className={
                    "absolute top-[calc(100%+4px)] right-0 z-50 [@media(max-width:1024px)]:left-0 [@media(max-width:1024px)]:right-auto"
                  }
                >
                  <DropdownColumns columns={A} />
                </div>
              )}
            </div>
            <div className={"relative"} {...w("dynamics")}>
              <NavItem
                label={translate("nav.dynamics")}
                hasDropdown={true}
                isOpen={"dynamics" === d}
              />
              {"dynamics" === d && (
                <div className={"absolute top-[calc(100%+4px)] right-0 z-50"}>
                  <DropdownSections sections={D} />
                </div>
              )}
            </div>
            <div className={"relative"} {...w("pricing")}>
              <NavItem
                label={translate("nav.pricing")}
                hasDropdown={true}
                isOpen={"pricing" === d}
              />
              {"pricing" === d && (
                <div className={"absolute right-0 top-[calc(100%+4px)] z-50"}>
                  <DropdownSections sections={I} />
                </div>
              )}
            </div>
            {z && (
              <jsxRuntime.Fragment>
                <NavItem
                  label={translate("nav.docCenter")}
                  href={"/docs/welcome"}
                />
                <NavItem
                  label={translate("nav.pricing")}
                  href={"/docs/price/pay-as-you-go"}
                />
              </jsxRuntime.Fragment>
            )}
            <div className={"relative"} {...w("language")}>
              <div
                className={(0, ClassNamesModule.cn)(
                  "flex items-center gap-[2px] h-[36px] px-[12px] py-[4px] rounded-[6px] cursor-pointer transition-colors",
                  "language" === d
                    ? "bg-[var(--color-border-warm)]"
                    : "hover:bg-[#f5f5f5]",
                )}
              >
                <span
                  className={
                    "text-[14px] leading-[22px] text-black whitespace-nowrap"
                  }
                >
                  {"zh" === language ? "中文" : "English"}
                </span>
                <ChevronDown
                  size={12}
                  className={(0, ClassNamesModule.cn)(
                    "text-black transition-transform duration-200",
                    "language" === d && "-scale-y-100",
                  )}
                />
              </div>
              {"language" === d && (
                <div className={"absolute top-[calc(100%+4px)] right-0 z-50"}>
                  <DropdownSections
                    sections={[
                      {
                        items: [
                          {
                            label: "中文",
                            onClick: () => C("zh"),
                          },
                          {
                            label: "English",
                            onClick: () => C("en"),
                          },
                        ],
                      },
                    ]}
                  />
                </div>
              )}
            </div>
            {b && (
              <div className={"relative"} {...w("useMiMo")}>
                <a
                  href={DestinationsModule.useMiMoUrl}
                  target={"_blank"}
                  rel={"noopener noreferrer"}
                  className={(0, ClassNamesModule.cn)(
                    "flex items-center gap-[4px] h-[36px] px-[17px] py-[9px] rounded-[6px] cursor-pointer bg-black border border-black transition-opacity hover:opacity-90",
                  )}
                >
                  <span
                    className={
                      "text-[14px] leading-[22px] text-white whitespace-nowrap"
                    }
                  >
                    {translate("nav.useMiMo")}
                  </span>
                  <ChevronDown
                    size={12}
                    className={(0, ClassNamesModule.cn)(
                      "text-white transition-transform duration-200",
                      "useMiMo" === d && "-scale-y-100",
                    )}
                  />
                </a>
                {"useMiMo" === d && (
                  <div className={"absolute top-[calc(100%+4px)] right-0 z-50"}>
                    <DropdownSections sections={v} />
                  </div>
                )}
              </div>
            )}
            {S && (
              <a
                href={"https://platform.xiaomimimo.com/console/balance"}
                target={"_blank"}
                rel={"noopener noreferrer"}
                className={
                  "flex items-center h-[36px] px-[12px] py-[8px] rounded-[6px] text-[14px] leading-[22px] text-black hover:bg-[var(--color-border-warm)] transition-colors"
                }
              >
                {translate("nav.console")}
              </a>
            )}
            {z && <LanguagePlaceholder isTransparent={N} />}
          </div>
        </div>
      </nav>
    )
  );
};
export {
  NewBadge,
  DropdownItem,
  DropdownSections,
  DropdownColumns,
  LanguagePlaceholder,
  NavItem,
  DesktopNav,
};
